/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Asset,
    AssetFromJSON,
    AssetToJSON,
    AssetMetadata,
    AssetMetadataFromJSON,
    AssetMetadataToJSON,
    CollageLayers,
    CollageLayersFromJSON,
    CollageLayersToJSON,
} from '../models';

export interface CreateCollageDru1Request {
    sessionId: string;
    collageLayers?: CollageLayers;
}

export interface CreateDefaultDru1Request {
    sessionId: string;
    pieceCount: string;
    format: string;
    customProductType: string;
}

export interface CreateDru1Request {
    sessionId: string;
    customProductType: string;
    asset?: Asset;
}

export interface GetAssetRequest {
    sessionId: string;
    assetId: string;
}

export interface SimpleUploadRequest {
    sessionId: string;
    customProductType: string;
    filename: string;
    body?: Blob;
}

export interface UpdateAssetAttributesRequest {
    sessionId: string;
    customProductType: string;
    asset?: Asset;
}

export interface UploadRequest {
    sessionId: string;
    customProductType: string;
    image?: Blob;
}

/**
 * no description
 */
export class AssetApi extends runtime.BaseAPI {

    /**
     * create collage dru1
     * create collage dru1
     */
    async createCollageDru1Raw(requestParameters: CreateCollageDru1Request): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling createCollageDru1.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/collage/dru1/create/{sessionId}`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CollageLayersToJSON(requestParameters.collageLayers),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * create collage dru1
     * create collage dru1
     */
    async createCollageDru1(requestParameters: CreateCollageDru1Request): Promise<string> {
        const response = await this.createCollageDru1Raw(requestParameters);
        return await response.value();
    }

    /**
     * create default dru1 asset
     * create default dru1 asset
     */
    async createDefaultDru1Raw(requestParameters: CreateDefaultDru1Request): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling createDefaultDru1.');
        }

        if (requestParameters.pieceCount === null || requestParameters.pieceCount === undefined) {
            throw new runtime.RequiredError('pieceCount','Required parameter requestParameters.pieceCount was null or undefined when calling createDefaultDru1.');
        }

        if (requestParameters.format === null || requestParameters.format === undefined) {
            throw new runtime.RequiredError('format','Required parameter requestParameters.format was null or undefined when calling createDefaultDru1.');
        }

        if (requestParameters.customProductType === null || requestParameters.customProductType === undefined) {
            throw new runtime.RequiredError('customProductType','Required parameter requestParameters.customProductType was null or undefined when calling createDefaultDru1.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/default/dru1/create/{sessionId}/{pieceCount}/{format}/{customProductType}`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))).replace(`{${"pieceCount"}}`, encodeURIComponent(String(requestParameters.pieceCount))).replace(`{${"format"}}`, encodeURIComponent(String(requestParameters.format))).replace(`{${"customProductType"}}`, encodeURIComponent(String(requestParameters.customProductType))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * create default dru1 asset
     * create default dru1 asset
     */
    async createDefaultDru1(requestParameters: CreateDefaultDru1Request): Promise<string> {
        const response = await this.createDefaultDru1Raw(requestParameters);
        return await response.value();
    }

    /**
     * create dru1 asset
     * create dru1 asset
     */
    async createDru1Raw(requestParameters: CreateDru1Request): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling createDru1.');
        }

        if (requestParameters.customProductType === null || requestParameters.customProductType === undefined) {
            throw new runtime.RequiredError('customProductType','Required parameter requestParameters.customProductType was null or undefined when calling createDru1.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/asset/{sessionId}/{customProductType}/dru1/create`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))).replace(`{${"customProductType"}}`, encodeURIComponent(String(requestParameters.customProductType))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssetToJSON(requestParameters.asset),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * create dru1 asset
     * create dru1 asset
     */
    async createDru1(requestParameters: CreateDru1Request): Promise<string> {
        const response = await this.createDru1Raw(requestParameters);
        return await response.value();
    }

    /**
     * get asset metadata
     * get asset metadata
     */
    async getAssetRaw(requestParameters: GetAssetRequest): Promise<runtime.ApiResponse<AssetMetadata>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling getAsset.');
        }

        if (requestParameters.assetId === null || requestParameters.assetId === undefined) {
            throw new runtime.RequiredError('assetId','Required parameter requestParameters.assetId was null or undefined when calling getAsset.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/asset/{sessionId}/{assetId}`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))).replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters.assetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetMetadataFromJSON(jsonValue));
    }

    /**
     * get asset metadata
     * get asset metadata
     */
    async getAsset(requestParameters: GetAssetRequest): Promise<AssetMetadata> {
        const response = await this.getAssetRaw(requestParameters);
        return await response.value();
    }

    /**
     * upload a new asset as as simple body content
     * upload a new asset as as simple body content
     */
    async simpleUploadRaw(requestParameters: SimpleUploadRequest): Promise<runtime.ApiResponse<Asset>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling simpleUpload.');
        }

        if (requestParameters.customProductType === null || requestParameters.customProductType === undefined) {
            throw new runtime.RequiredError('customProductType','Required parameter requestParameters.customProductType was null or undefined when calling simpleUpload.');
        }

        if (requestParameters.filename === null || requestParameters.filename === undefined) {
            throw new runtime.RequiredError('filename','Required parameter requestParameters.filename was null or undefined when calling simpleUpload.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/octet-stream';

        const response = await this.request({
            path: `/asset/{sessionId}/{customProductType}/{filename}`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))).replace(`{${"customProductType"}}`, encodeURIComponent(String(requestParameters.customProductType))).replace(`{${"filename"}}`, encodeURIComponent(String(requestParameters.filename))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetFromJSON(jsonValue));
    }

    /**
     * upload a new asset as as simple body content
     * upload a new asset as as simple body content
     */
    async simpleUpload(requestParameters: SimpleUploadRequest): Promise<Asset> {
        const response = await this.simpleUploadRaw(requestParameters);
        return await response.value();
    }

    /**
     * update asset attributes
     * update asset attributes
     */
    async updateAssetAttributesRaw(requestParameters: UpdateAssetAttributesRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling updateAssetAttributes.');
        }

        if (requestParameters.customProductType === null || requestParameters.customProductType === undefined) {
            throw new runtime.RequiredError('customProductType','Required parameter requestParameters.customProductType was null or undefined when calling updateAssetAttributes.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/asset/{sessionId}/{customProductType}/update/attributes`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))).replace(`{${"customProductType"}}`, encodeURIComponent(String(requestParameters.customProductType))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssetToJSON(requestParameters.asset),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * update asset attributes
     * update asset attributes
     */
    async updateAssetAttributes(requestParameters: UpdateAssetAttributesRequest): Promise<string> {
        const response = await this.updateAssetAttributesRaw(requestParameters);
        return await response.value();
    }

    /**
     * upload a new asset
     * upload a new asset
     */
    async uploadRaw(requestParameters: UploadRequest): Promise<runtime.ApiResponse<Asset>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling upload.');
        }

        if (requestParameters.customProductType === null || requestParameters.customProductType === undefined) {
            throw new runtime.RequiredError('customProductType','Required parameter requestParameters.customProductType was null or undefined when calling upload.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.image !== undefined) {
            formParams.append('image', requestParameters.image as any);
        }

        const response = await this.request({
            path: `/asset/{sessionId}/{customProductType}`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))).replace(`{${"customProductType"}}`, encodeURIComponent(String(requestParameters.customProductType))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetFromJSON(jsonValue));
    }

    /**
     * upload a new asset
     * upload a new asset
     */
    async upload(requestParameters: UploadRequest): Promise<Asset> {
        const response = await this.uploadRaw(requestParameters);
        return await response.value();
    }

}
